import { Grid, Typography } from '@mui/material'
import { grey } from '@mui/material/colors';
import { memo } from 'react';
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import queryString from 'query-string';
import ModalReservationImagenologia from 'src/Reservation/ModalReservationImagenologia';
import CalendarVerticalImagenologia from 'src/SearchHours/components/calendars/CalendarVerticalImagenologia';
import { dayDefaultAvailableState, showCalendarHorizontalState } from 'src/SearchHours/components/calendars/state/atoms';
import FiltersSearchImagenologia from 'src/SearchHours/FiltersSearchImagenologia';
import useSearchHours from 'src/SearchHours/hooks/useSearchHours';
import { capitalizeWord, serializeDateFormatLong } from 'src/shared/global/helpers';
import ListImagenologia from './components/ListImagenologia';
import { filterSearchSelectedState, hoursAvailableState, loadingDaysCalendarState, loadingHoursState } from 'src/SearchHours/state/atoms';
import { useRef } from 'react';
import AlertCustom from 'src/shared/components/alerts/AlertCustom';
import HoursAvailableSkeleton from 'src/shared/components/skeletons/HoursAvailableSkeleton';
import useSEO from 'src/Hooks/useSEO';

const Index = memo(() => {
    const dayDefaultAvailable = useRecoilValue(dayDefaultAvailableState);
    const hoursAvailable = useRecoilValue(hoursAvailableState)
    const loadingHours = useRecoilValue(loadingHoursState);
    const setShowCalendarHorizontal = useSetRecoilState(showCalendarHorizontalState)
    const [filterSearchSelected] = useRecoilState(filterSearchSelectedState);
    const setFilterSearchSelected = useSetRecoilState(filterSearchSelectedState);
    const { loadDaysAvailableImagenologiaAndDefault, loadHoursImagenologiaAvailable, isEmptyFiltersImagenologia } = useSearchHours();
    const loadingDaysCalendar = useRecoilValue(loadingDaysCalendarState)
    const location = useLocation();
    const query = queryString.parse(location.search)
    const mountedC = useRef(false);
    const query2 = queryString.parse(window.location.search)
    const [showLoading, setShowLoading] = useState(true);

    const initSEO = () => {
        if(query2 && query2.ra_id !== undefined && query2.ra_id !== ""){
            document.title = `Reagendar: Clínica Andes Salud ${process.env.REACT_APP_SEDE}`;
            const el = document.querySelector("meta[name='title']");
            el.setAttribute('content','Reagendar');
        }
    };

    useEffect(()=> {
        initSEO();

        if(showLoading){
            if (navigator.userAgent.match(/Android|iPhone|iPad|iPod/i)) {
                console.log("MOVILES");
                //refresh();
                //setTimeout( () => window.location.reload() , 1000 );
                setShowLoading(false);
            }
        }

    }, [])

    useEffect(() => {
        mountedC.current = true;
        setShowCalendarHorizontal(true);
        console.log("useEffect 0 => setShowCalendarHorizontal")
        return () => {
            mountedC.current = false;
            setShowCalendarHorizontal(false);
            // resetSearchAndResultHours()
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        console.log("useEffect 1");        
        const queryParamsLength = !query ? 0 : Object.keys(query).length;
        //console.log(`dayDefaultAvailable =>  ${dayDefaultAvailable} | queryParamsLength ${queryParamsLength} | loadingDaysCalendar ${loadingDaysCalendar}`);
        if (!dayDefaultAvailable && queryParamsLength === 0 && !loadingDaysCalendar && !isEmptyFiltersImagenologia()) {
            console.log("useEffect 1 => loadDaysAvailableImagenologiaAndDefault => imagenologia");
            //loadDaysAvailableAndDefault()
            loadDaysAvailableImagenologiaAndDefault()
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadDaysAvailableImagenologiaAndDefault])

    useEffect(() => {
        console.log("useEffect 2");
        console.log(`dayDefaultAvailable ${dayDefaultAvailable} | loadingHours ${loadingHours} | hoursAvailable ${hoursAvailable}`);
        if (dayDefaultAvailable && !loadingHours && hoursAvailable.length === 0) {
            console.log("useEffect 2 => loadHoursImagenologiaAvailable");
            loadHoursImagenologiaAvailable();
            console.log(`dayDefaultAvailable ${dayDefaultAvailable} | loadingHours ${loadingHours} | hoursAvailable ${hoursAvailable}`);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dayDefaultAvailable])


    return (
        <Grid
            container paddingY={2}
        >
            {
                query && Object.keys(query).length > 0 && query.ra_id !== undefined && query.ra_id !== "" ?
                    <AlertCustom
                        severity="info"
                        children={
                            <>
                                Anteriormente realizó una reserva para el día <strong>{capitalizeWord(serializeDateFormatLong(new Date(sessionStorage.getItem("dateReservationCanceled"))?.toISOString().split("T")[0]), true)} con el Dr(a) {filterSearchSelected.professionalSelected.value}</strong>. Puede volver a agendar una nueva hora para el mismo día o la fecha que usted desee.
                            </>
                        }
                        style={{ marginBottom: 16, width: '100%' }}
                    /> : null
            }
            <ModalReservationImagenologia />
            <Grid item xs={12} md={8} lg={9}>
                <FiltersSearchImagenologia />
                <Typography variant='h3' color={grey[700]} mb={2} style={{ textTransform: 'uppercase' }}>
                    {serializeDateFormatLong(dayDefaultAvailable?.toISOString().split("T")[0])}
                </Typography>
                {
                    (loadingHours || loadingDaysCalendar) && hoursAvailable.length === 0 ? (<HoursAvailableSkeleton />)
                        : (<ListImagenologia />)

                }
            </Grid>

            <Grid item xs={12} md={4} lg={3} paddingLeft={2}>
                <CalendarVerticalImagenologia />
            </Grid>
        </Grid>
    )
})


export default Index;